import React, { useState, useEffect } from "react";
import CancelIcon from "@mui/icons-material/Cancel";

function EditLowStockModal({ newData, setNewData, setEditTab, handleSubmit }) {
  const [editData, setEditData] = useState({});

  // Sync editData with newData when newData changes
  useEffect(() => {
    if (newData) {
      setEditData({
        ...newData,
        quantity: newData.available_quantity || newData.quantity || 0, // Default to 0 if not available
      });
    }
  }, [newData]);

  const handleChange = (e) => {
    const { value } = e.target;
    setEditData((prevData) => ({
      ...prevData,
      quantity: value, // Update quantity in state
    }));
  };

  const handleClose = () => {
    setEditTab(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={handleClose}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        <h2 className="text-center font-semibold text-2xl mb-2">
          Edit Low Stock
        </h2>
        <div>
          <h3 className="font-medium">Product Quantity</h3>
          <input
            className="border-2 border-gray-300 p-2 pl-4 rounded-md focus:border-teal-500 focus:outline-none lg:w-[300px]"
            placeholder="Quantity"
            type="number"
            name="quantity"
            value={editData.quantity || ""} // Ensure controlled input
            onChange={handleChange}
            required
          />
        </div>

        <button
          onClick={() => handleSubmit(editData)}
          type="submit"
          className="px-4 py-3 mt-4 text-white rounded-lg w-full lg:w-[300px] bg-blue-500"
        >
          Update
        </button>
      </div>
    </div>
  );
}

export default EditLowStockModal;
